import React from 'react';
import { useTranslation } from 'react-i18next';

import type { IDependent, IMessageItem, IValuesError } from 'pages/UserPages/ProfitCentres/interfaces/IArchiveError';
import type IErrorList from './interfaces/IErrorList';

import styles from './sass/ArchiveRestrictedModal.module.scss';

function ErrorList({ archiveError }: IErrorList) {
  const { t } = useTranslation();

  if (!archiveError?.data?.message?.length) return null;

  const formattedTitle = (title: string) => {
    const spacedText = title.replace(/-/g, ' ').replace(/([A-Z])/g, ' $1').trim();
    return spacedText.charAt(0).toUpperCase() + spacedText.slice(1).replace(/\bcenter\b/g, 'centre');
  };

  return (
    <>
      {archiveError.data.message.flat().map((errorItem: IMessageItem) => {
        const { params, errorCode } = errorItem;
        const { recordType, values } = params;

        return values.map((value: IValuesError) => (
          <React.Fragment key={`error-${errorCode}-${value.name}`}>
            <li>
              [
              {recordType && typeof recordType === 'object' ? formattedTitle(recordType?.targetRecordType)
                : formattedTitle(recordType)}
              ]
              {' '}
              <strong>{value.name}</strong>
              {' '}
              {t('common.isCurrentlyInUseBy')}
            </li>
            <ul className={styles.subList}>
              {value.dependents.map((dependent: IDependent) => (
                <li key={[dependent.type, dependent.name].join('_')}>
                  {formattedTitle(dependent.type)}
                  : [
                  {dependent.name}
                  ]
                </li>
              ))}
            </ul>
          </React.Fragment>
        ));
      })}
    </>
  );
}

export default ErrorList;
